export type AppHeaderProps = {
  title?: string;
}

export const AppHeader = (props: AppHeaderProps) => {
    return (
        <header className="App-header px-3">
          <h1 style={{position: 'absolute', top: '-10em'}}>SuperAI</h1>
          <nav className="navbar navbar-dark">
            <div className="material-icons-outlined text-white cursor-pointer" onClick={() => {
                window.history.go(-1);
            }}>arrow_back</div>
            <div className="font-weight-bold text-white">{props.title}</div>
            <span className="material-icons-outlined text-white">search</span>
          </nav>
        </header>
    )
}